import PaginatorComponent from './paginator-component';

/***
 * A paginator, to be added to the bottom of a list of items and used for sorting through multiple pages.
 */
const Paginator = angular
    .module('FacilityData.Common.Paginator', [])
    .component('paginator', PaginatorComponent)
    .name;

export default Paginator;


// WEBPACK FOOTER //
// ./app/common/paginator/paginator.js